import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <Container
            maxWidth="md"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '80vh',
                textAlign: 'center',
            }}
        >
            <Box>
                <Typography variant="h1" color={theme.palette.primary.main} fontWeight="bold">
                    401
                </Typography>
                <Typography variant="h5" sx={{ mb: 3 }}>
                    You are not authorized to access this page.
                </Typography>
                <Button variant="contained" color="primary" onClick={() => navigate('/signin')}>
                    Go to Sign In
                </Button>
            </Box>
        </Container>
    );
};

export default Unauthorized;
